export default function masterVendorDirective(
  $q,
  vmDataService
) {
  console.log('app.components.admin.vendorManagementAdmin.masterVendorUniqueNameValidator created');
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attributes, ngModel) => {
      const masterVendorId = attributes.masterVendorId || -1;
      ngModel.$asyncValidators.ssMasterVendorUniqueName = (modelValue) => {
        const defer = $q.defer();
        vmDataService.validateMasterVendorDuplicateName(
          masterVendorId,
          modelValue
        ).then((data) => {
          if (data && !data.data.result) {
            defer.resolve();
          } else {
            defer.reject();
          }
        }).catch(defer.reject);
        return defer.promise;
      };
    },
  };
}

masterVendorDirective.$inject = [
  '$q',

  'vmDataService',
];
